import React from 'react'
import { Users, Clock, Flame, Star } from 'lucide-react'

const TrustBar = () => {
  const stats = [
    {
      icon: Clock,
      value: '2.1M+',
      label: 'Minutes Prayed',
    },
    {
      icon: Users,
      value: '127K+',
      label: 'Active Users',
    },
    {
      icon: Flame,
      value: '18K+',
      label: 'Prayer Pods',
    },
  ]

  return (
    <section className="bg-grace-gray py-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-center">
          {/* Stats */}
          {stats.map((stat, index) => {
            const Icon = stat.icon
            return (
              <div key={index} className="text-center animate-on-scroll">
                <div className="flex justify-center mb-2">
                  <Icon size={32} className="text-prayer-blue" />
                </div>
                <div className="text-2xl md:text-3xl font-bold text-heading-dark mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-body-gray">{stat.label}</div>
              </div>
            )
          })}

          {/* Testimonial Quote */}
          <div className="text-center md:text-left animate-on-scroll">
            <div className="flex justify-center md:justify-start mb-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star key={i} size={16} className="fill-streak-gold text-streak-gold" />
              ))}
            </div>
            <p className="text-sm italic text-body-gray mb-2">
              &ldquo;Finally beat my Instagram addiction through prayer!&rdquo;
            </p>
            <p className="text-xs text-muted-gray">- Naledi M., 3-month user</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TrustBar
